(ns teamoesterreich.user-mode.modal.info-popup
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.done :refer [done]]
            [reagent.core :as r]))



(defn info-modal [!show-message ok-message on-ok-fn]

  [mui/modal
   {
    :aria-labelledby  "simple-modal-title"
    :aria-describedby "simple-modal-description"
    :style            {:display        "flex"
                       :marginRight    "auto"
                       :marginLeft     "auto"
                       :alignItems     "center"
                       :justifyContent "center"}
    :open             (if @!show-message true false)

    }
   [:div
    {
     :class "modal"
     :style {:min-width 400}}
    [:h4 @!show-message]

    [:br]
    [:br]

    [mui/button
     {:style     {:float "right"}
      :variant   "contained"
      :startIcon (r/as-element [done])
      :onClick   (fn []
                   (on-ok-fn)
                   (reset! !show-message nil))
      }
     ok-message]]
   ]
  )
